<!-- prettier-ignore -->
<template>
  <div class="home-page-container" ref="container">
    <div class="bg-container" :class="{ 'animate-bg': isVisible }"></div>
    <div v-if="isVisible" class="content-wrapper">
      <div class="text-content">
        <h1 class="title animate-up-fade">INSPAY</h1>
        <p class="subtitle animate-up-fade-delay-1">
          A new payment experience that<br />
          combines reality and reality
        </p>
        <div class="download-buttons animate-up-fade-delay-2">
          <div class="download-item">
            <img src="@/assets/imgsnew/appstore.png" alt="Download on App Store" class="store-button"
              @click="showModal = true" />
            <div class="app-info">
              <img src="@/assets/imgsnew/insmartpay.png" alt="Insmartpay icon" class="app-icon" />
              <span class="app-name">InsmartPay</span>
            </div>
          </div>
          <div class="download-item">
            <img src="@/assets/imgsnew/android.png" alt="Download on Android" class="store-button"
              @click="showModal = true" />
            <div class="app-info">
              <img src="@/assets/imgsnew/inspay.png" alt="Inspay icon" class="app-icon" />
              <span class="app-name">InsPay</span>
            </div>
          </div>
        </div>
        <p class="download-text" @click="showModal = true">
          <span>Get your channel code for card discount. Tap to get &gt;</span>
        </p>
      </div>
    </div>
    <div v-if="isVisible" class="image-overlay animate-left">
      <img src="@/assets/imgsnew/home2.svg" alt="Payment Card" class="card-image" />
    </div>

    <!-- 弹框组件 -->
    <Transition name="modal">
      <div v-if="showModal" class="modal-overlay" @click="showModal = false">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <div class="header-title">
              <h2>Channel Code</h2>
            </div>
            <button class="close-button" @click="showModal = false">
              <img src="@/assets/imgsnew/Vector.png" alt="close" class="close-icon" />
            </button>
          </div>
          <div class="modal-body">
            <!-- 弹框内容区域 -->
            <div class="modal-content-body">
              <!-- 获取渠道吗 -->
              <div class="modal-content-body-title">
                <div class="modal-content-body-code" @click="copyChannelCode">
                  <span>{{ currentChannelCode }}</span>
                  <span v-if="currentChannelCode !== 'Click to Get Channel Code'">&nbsp;</span>
                  <img v-if="currentChannelCode !== 'Click to Get Channel Code'" src="@/assets/imgsnew/copy.png"
                    alt="copy" class="copy-icon" />
                </div>
              </div>
              <!-- 渠道码注释 -->
              <div class="modal-content-body-code-text">
                <span>Fill in the channel code on the registration page to register
                  and get an exclusive card opening discount</span>
              </div>
              <!-- 渠道码说明 -->
              <div class="modal-content-body-code-text2">
                <span>Channel Code Instructions:</span>
                <div class="modal-content-body-code-text2-img">
                  <img src="@/assets/imgsnew/qietu3.png" alt="code" />
                </div>
              </div>
              <!-- 操作步骤 -->
              <div class="modal-content-body-code-text2-img-text">
                <p>
                  <span>STEP1：</span>Open the app, tap the "Create Account"
                  button, and go to the registration page
                </p>
                <p>
                  <span>STEP2：</span>Enter your exclusive channel code on the
                  registration page and complete the registration to enjoy the
                  card opening discount
                </p>
              </div>
              <!-- 下载按钮 -->
              <div>
                <div class="modal-content-body-download">
                  <div class="download-item">
                    <img src="@/assets/imgsnew/appstore.png" alt="Download on App Store" class="store-button"
                      @click="iosDownload()" />
                    <div class="app-info">
                      <img src="@/assets/imgsnew/insmartpay.png" alt="Insmartpay icon" class="app-icon" />
                      <span class="app-name">InsmartPay</span>
                    </div>
                  </div>
                  <div class="download-item">
                    <img src="@/assets/imgsnew/android.png" alt="Download on Android" class="store-button"
                      @click="download()" />
                    <div class="app-info">
                      <img src="@/assets/imgsnew/inspay.png" alt="Inspay icon" class="app-icon" />
                      <span class="app-name">InsPay</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: "HomePageOne",
  data() {
    return {
      isVisible: true,
      observer: null,
      showModal: false,
      channelCodes: [
        "inspay",
        "ohzttg",
        "kvgapr",
        "xuhyko",
        "bcnzzo",
        "apinjw",
        "povybe",
        "pqthcm",
        "xcffxk",
        "eyvpbm",
        "pvyxvy",
        "ljvucr",
        "cvfgdk",
        "bkwadk",
        "crpxtl",
        "efhnft",
        "nnatab",
        "vlzpoo",
        "bflevs",
        "gofaqr",
        "gcmlou",
      ],
      currentChannelCode: "Click to Get Channel Code",
    };
  },
  watch: {
    showModal(val) {
      if (val) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    },
  },
  mounted() {
    this.setupObserver();
  },
  beforeUnmount() {
    // 清理 observer
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    download() {
      window.location.href =
        "https://d1qv1lnrgfy0u7.cloudfront.net/apk/inspay.apk";
      this.showModal = false;
    },

    iosDownload() {
      window.location.href =
        "https://apps.apple.com/hk/app/insmartpay/id6738124852";
      this.showModal = false;
    },

    setupObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              this.isVisible = false;
            } else {
              setTimeout(() => {
                this.isVisible = true;
              }, 100);
            }
          });
        },
        {
          threshold: 0.2,
        }
      );

      this.observer.observe(this.$refs.container);
    },

    getRandomChannelCode() {
      const randomIndex = Math.floor(Math.random() * this.channelCodes.length);
      this.currentChannelCode = this.channelCodes[randomIndex];
    },

    async copyChannelCode() {
      if (this.currentChannelCode == "Click to Get Channel Code") {
        this.getRandomChannelCode();
        return;
      }

      try {
        // 创建临时文本区域
        const textArea = document.createElement("textarea");
        textArea.value = this.currentChannelCode;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        textArea.style.top = "0";
        document.body.appendChild(textArea);

        // 在移动设备上，需要将文本区域滚动到可见区域
        textArea.focus();
        textArea.select();

        // 对于iOS设备
        const range = document.createRange();
        range.selectNodeContents(textArea);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        textArea.setSelectionRange(0, textArea.value.length);

        // 执行复制
        const successful = document.execCommand("copy");
        document.body.removeChild(textArea);

        if (successful) {
          alert("Channel code copied successfully!");
        } else {
          alert("no");
        }
      } catch (err) {
        console.error("复制失败:", err);
        alert("no");
      }
    },
  },
};
</script>

<style scoped>
.home-page-container {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.modal-content-body-code-text span {
  display: block;
  font-family: MiSans;
  font-weight: 400;
  font-size: 12px;
  line-height: 15.91px;
  letter-spacing: 0%;
  padding: 10px 0;
}

.modal-content-body-download {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.modal-content-body-download .download-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.modal-content-body-download .store-button {
  width: 420px;
  height: auto;
  cursor: pointer;
  transition: transform 0.2s;
}

.modal-content-body-download .store-button:hover {
  transform: scale(1.05);
}

.modal-content-body-download .app-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-content-body-download .app-icon {
  width: 20px;
  height: 20px;
}

.modal-content-body-download .app-name {
  font-size: 12px;
  color: #333;
}

.modal-content-body-code-text2 span {
  display: block;
  font-family: MiSans;
  font-weight: 600;
  font-size: 16px;
  line-height: 15.91px;
  letter-spacing: 0%;
  padding-bottom: 10px;
}

.modal-content-body-code-text2-img-text span {
  color: red;
  font-family: MiSans;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0%;
}

.modal-content-body-title {
  background: #eef4fe;
  width: 100%;
  border-radius: 20px;
  padding: 10px 10px;
}

.modal-content-body-code {
  width: 100%;
  height: 40px;
  background: #000000;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
  gap: 8px;
}

.modal-content-body-code:hover {
  background: #333333;
}

.modal-content-body-code span {
  color: #fff;
  font-family: MiSans;
  font-weight: 500;
  font-size: 16px;
  line-height: 23.87px;
  letter-spacing: 0%;
  user-select: all;
}

.modal-content-body-title h2 {
  font-family: MiSans;
  font-weight: 500;
  font-size: 14px;
  line-height: 23.87px;
  letter-spacing: 0%;
}

.bg-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("@/assets/imgsnew/home1.svg");
  background-size: cover;
  background-position: center;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.animate-bg {
  animation: bgScale 1.2s ease-out 0.9s forwards;
}

.content-wrapper {
  padding-left: 10%;
  z-index: 1;
  animation-fill-mode: both;
  z-index: 100 !important;
}

.download-text {
  font-size: 16px;
  color: #fff;
  margin-top: 10px;

  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.download-text span {
  display: inline-block;
  /* background-color: rgba(0, 56, 152, 0.4); */
  padding: 8px 0;
  border-radius: 4px;
  text-decoration: underline;
  font-weight: 600;
}

.text-content {
  color: white;
  margin-top: 10px;
  will-change: transform, opacity;
}

.download-buttons {
  display: flex;
  gap: 20px;
  margin-top: 30px;
  justify-content: flex-start;
}

.download-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.store-button {
  width: 160px;
  cursor: pointer;
  transition: transform 0.2s;
}

.store-button:hover {
  transform: scale(1.05);
}

.app-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.app-icon {
  width: 20px;
  height: 20px;
  /* border-radius: 6px; */
}

.app-name {
  font-size: 12px;
  color: #ffffff;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
}

.title {
  font-family: MiSans-Bold;
  font-size: 60px;
  font-weight: 900;
  line-height: 80px;
  letter-spacing: -0.03em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #ffffff;
  margin-top: -30px;
  opacity: 0;
}

.subtitle {
  font-family: MiSans-Bold;
  font-size: 36px;
  font-weight: 900;
  line-height: 60px;
  letter-spacing: -0.03em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 20px 0px;
}

.download-btn {
  background-color: #0047cc;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 30px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.download-btn:hover {
  background-color: #003399;
}

.image-overlay {
  position: absolute;
  right: 5%;
  bottom: 0;
  transform: none;
  z-index: 2;
  will-change: transform;
  animation-fill-mode: both;
}

.card-image {
  width: 605px;
  height: 715px;
  top: 185px;
  left: 835px;
  max-height: 80vh;
  object-fit: contain;
}

@media (max-width: 768px) {
  .home-page-container {
    height: 80vh;
    min-height: 80vh;
    padding: 0;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .content-wrapper {
    padding: 0 20px;
    width: 100%;
    margin: 0;
    text-align: center;
    z-index: 2;
    height: 55%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .text-content {
    text-align: center;
    margin: 0;
  }

  .title {
    font-size: 40px;
    line-height: 1.2;
    text-align: center;
    margin: 0;
    color: rgb(255, 255, 255);
  }

  .subtitle {
    font-size: 20px;
    line-height: 1.5;
    text-align: center;
    margin: 20px 0;
    color: white;
  }

  .download-btn {
    padding: 12px 32px;
    font-size: 16px;
    margin: 25px auto;
    display: inline-block;
    border-radius: 30px;
  }

  .image-overlay {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -20px;
    width: 100%;
    margin: 0;
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 2;
    height: 45%;
  }

  .card-image {
    width: 100%;
    height: auto;
    max-width: 375px;
    max-height: 100%;
    object-fit: contain;
    margin: 0;
    display: block;
    position: static;
    transform: none;
  }

  .bg-container {
    height: 80vh;
  }

  @keyframes slideLeft {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }

    20% {
      opacity: 1;
    }

    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .text-content .download-buttons {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-top: 30px;
    padding-left: 0;
  }

  .download-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }

  .app-info {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  .app-icon {
    width: 20px;
    height: 20px;
  }

  .app-name {
    font-size: 12px;
    color: #ffffff;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  }

  @keyframes slideLeft {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }

    20% {
      opacity: 1;
    }

    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .download-text {
    text-align: center;
    margin-top: 15px;
    font-size: 12px;
  }

  .modal-content-body-download {
    flex-direction: row;
    gap: 15px;
  }

  .modal-content-body-download .store-button {
    width: 140px;
    height: auto;
  }

  .modal-content-body-download .app-info {
    gap: 8px;
    margin-top: 8px;
  }

  .modal-content-body-download .app-icon {
    width: 24px;
    height: 24px;
  }

  .modal-content-body-download .app-name {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    margin-top: 60px;
  }

  .title {
    font-size: 36px;
  }

  .subtitle {
    font-size: 18px;
    margin: 15px 0;
    color: white;
  }

  .image-overlay {
    padding: 0 15px;
    bottom: -15px;
  }

  .card-image {
    max-width: 320px;
  }

  .card-image {
    width: 90%;
  }

  .text-content .download-buttons {
    padding-left: 0;
  }

  .text-content .store-button {
    width: 120px;
  }
}

@media (max-height: 667px) {
  .content-wrapper {
    margin-top: 40px;
  }

  .title {
    font-size: 32px;
  }

  .subtitle {
    font-size: 16px;
    margin: 12px 0;
    color: white;
  }

  .image-overlay {
    bottom: 20px;
  }

  .card-image {
    max-height: 40vh;
  }
}

.animate-up-fade {
  animation: upFade 1s ease-out forwards;
}

.animate-up-fade-delay-1 {
  animation: upFade 1s ease-out forwards;
  animation-delay: 0.3s;
  opacity: 0;
}

.animate-up-fade-delay-2 {
  animation: upFade 1s ease-out forwards;
  animation-delay: 0.6s;
  opacity: 0;
}

.animate-left {
  animation: slideLeft 1.2s ease-out forwards;
}

@keyframes upFade {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideLeft {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }

  20% {
    opacity: 1;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes bgScale {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.08);
  }

  100% {
    transform: scale(1);
  }
}

@media (max-width: 375px) {
  .image-overlay {
    height: 40%;
    bottom: -10px;
  }

  .modal-content {
    width: 95vw;
  }

  .modal-content-body-download .app-info {
    gap: 8px;
    margin-top: 8px;
  }

  .modal-content-body-download .app-icon {
    width: 24px;
    height: 24px;
  }

  .modal-content-body-download .app-name {
    font-size: 14px;
  }
}

@media (max-width: 320px) {
  .content-wrapper {
    padding-top: 15px;
  }

  .image-overlay {
    height: 35%;
    bottom: -8px;
  }

  .card-image {
    max-width: 250px;
  }
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  width: 30vw;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  z-index: 40;
  max-height: 90vh;
  overflow-y: auto;

  /* 添加滚动条样式 */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.modal-header {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.header-title {
  text-align: center;
}

.modal-header h2 {
  margin-top: 10px;
  font-size: 18px;
  color: #333;
  font-weight: 500;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  position: absolute;
  right: 0px;
  top: 65%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.close-button:hover {
  opacity: 0.8;
}

.modal-body {
  padding: 16px;
}

/* Modal Transition Animation */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-to,
.modal-leave-from {
  opacity: 1;
}

.copy-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .modal-content {
    width: 90vw;
    height: auto;
    max-height: 90vh;
  }

  .modal-header {
    /* padding: 20px; */
  }

  .modal-header h2 {
    font-size: 22px;
    margin-top: 20px;
  }

  .close-button {
    padding: 12px;
    right: 0px;
  }

  .close-icon {
    width: 20px;
    height: 20px;
  }

  .modal-content-body-title {
    height: auto;
    min-height: 60px;
    padding: 5px;
  }

  .modal-content-body-title h2 {
    font-size: 18px;
    margin-bottom: 8px;
  }

  .modal-content-body-code {
    height: 48px;
  }

  .modal-content-body-code span {
    font-size: 18px;
  }

  .copy-icon {
    width: 20px;
    height: 20px;
  }

  .modal-content-body-code-text span {
    padding: 10px 0;
    font-size: 12px;
    line-height: 1.6;
  }

  .modal-content-body-code-text2 span {
    font-size: 18px;
    padding-bottom: 15px;
    padding-top: 5px;
  }

  .modal-content-body-code-text2-img-text p {
    font-size: 12px;
    line-height: 1.6;
    margin: 12px 0;
  }

  .modal-content-body-code-text2-img-text span {
    font-size: 16px;
  }

  .modal-content-body-download {
    flex-direction: row;
    gap: 15px;
  }

  .modal-content-body-download img {
    width: 160px;
    height: 36px;
  }

  .modal-body {
    padding: 10px 20px 20px 20px;
  }

  .modal-content-body {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
}
</style>
